import { Common } from '@stockbit/ui';
import { NotificationCount } from './styled';

const { Iconmoon, IconWrapper } = Common;

interface NorificationIconProps {
  count: number;
  onClick?: () => void;
}

const NotificationIcon = (iconProps: NorificationIconProps) => (
  <IconWrapper {...iconProps} size="40px">
    <Iconmoon size="30px" className="icon-panel_notification" />
    {iconProps.count > 0 && (
      <NotificationCount>
        {iconProps.count > 99 ? '99+' : iconProps.count}
      </NotificationCount>
    )}
  </IconWrapper>
);

export default NotificationIcon;
